import React from 'react';
import { Link } from 'react-router-dom';

import './Pagination.scss';
import { range, inheritUrl } from '../../../utils/easy';

interface Props {
  max: number;
  current: number;
  base?: string;
  searchKey?: string;
  searchValue?: string;
  nextDots?: number;
  prevDots?: number;
  query?: string;
  nextText?: string;
  prevText?: string;
  onChange?: (index: number, prev: number) => void;
}

class Pagination extends React.Component<Props> {

  static defaultProps = {
    base: '',
    query: 'page',
    nextDots: 2,
    prevDots: 1,
    nextText: 'بعدی',
    prevText: 'قبلی',
    searchKey: null,
    searchValue: null
  }

  static getDerivedStateFromProps(props: any, state: any) {
    let changes: any = {};
    if (props.current !== state.current) {
      changes.current = props.current;
    }
    if (props.max !== state.max) {
      changes.max = props.max;
    }
    if (props.searchKey !== state.searchKey) {
      changes.searchKey = props.searchKey;
    }
    if (props.searchValue !== state.searchValue) {
      changes.searchValue = props.searchValue;
    }
    if (props.max === 0) {
      changes.max = 1;
    }
    if (Object.keys(changes).length > 0) {
      return changes;
    }
    return null;
  }

  state = {
    base: this.props.base,
    max: this.props.max,
    current: this.props.current,
    searchKey: this.props.searchKey,
    searchValue: this.props.searchValue
  }

  render() {
    const { current, max } = this.state;
    const isFirst = current === 1;
    const isLast = current === max;
    return (
      <nav className="pagination-component">
        <ul className="pagination">
          <li className={'page-item' + (isFirst ? ' disabled' : '')}>
            <Link
              className="page-link"
              to={this.makeUrl(current - 1)}
              onClick={this.onChange.bind(this, current - 1)}>
              {this.props.prevText}
            </Link>
          </li>
          {this.renderFirst()}
          {this.renderPrev()}
          {this.renderCurrent()}
          {this.renderNext()}
          {this.renderLast()}
          <li className={'page-item' + (isLast ? ' disabled' : '')}>
            <Link
              className="page-link"
              to={this.makeUrl(current + 1)}
              onClick={this.onChange.bind(this, current + 1)}>
              {this.props.nextText}
            </Link>
          </li>
        </ul>
      </nav>
    );
  }

  private renderFirst() {
    const { current } = this.state;
    if (current === 1) return '';
    return (
      <li className="page-item">
        <Link
          to={this.makeUrl(1)}
          className="page-link"
          onClick={this.onChange.bind(this, 1)}>{1}</Link>
      </li>
    );
  }

  private renderLast() {
    const { current, max } = this.state;
    if (current === max) return '';
    return (
      <li className="page-item">
        <Link
          to={this.makeUrl(max)}
          className="page-link"
          onClick={this.onChange.bind(this, max)}>{max}</Link>
      </li>
    );
  }

  private renderCurrent() {
    const { current, max } = this.state;
    if (current > max) return '';
    return (
      <li className="page-item active">
        <Link to={this.makeUrl(current)} className="page-link">{current}</Link>
      </li>
    );
  }

  private renderPrev() {
    const prevDots = this.props.prevDots;
    const { current, max } = this.state;
    if (current > max) return '';
    const prevIndexes = range(current - prevDots, current).filter(i => i > 1);
    const prevItems = (
      <>
        {prevIndexes.map(i => (
          <li className="page-item" key={i}>
            <Link
              to={this.makeUrl(i)}
              className="page-link"
              onClick={this.onChange.bind(this, i)}>{i}</Link>
          </li>
        ))}
      </>
    );
    if (current - prevDots > 2) {
      return (
        <>
          <li className="page-item disabled">
            <Link to={'#'} className="page-link">...</Link>
          </li>
          {prevItems}
        </>
      );
    }
    return prevItems;
  }

  private renderNext() {
    const nextDots = this.props.nextDots;
    const { current, max } = this.state;
    if (current > max) return '';
    const nextIndexes = range(current + 1, current + nextDots + 1).filter(i => i < max);
    const nextItems = (
      <>
        {nextIndexes.map(i => (
          <li className="page-item" key={i}>
            <Link
              to={this.makeUrl(i)}
              className="page-link"
              onClick={this.onChange.bind(this, i)}>{i}</Link>
          </li>
        ))}
      </>
    );
    if (current + nextDots < max - 1) {
      return (
        <>
          {nextItems}
          <li className="page-item disabled">
            <Link to={'#'} className="page-link">...</Link>
          </li>
        </>
      );
    }
    return nextItems;
  }

  private makeUrl = (index: number) => {
    const { query } = this.props;
    const { base, searchKey, searchValue } = this.state;
    const custom = {};
    custom[query] = index;
    if (searchKey) {
      custom[searchKey] = searchValue;
    }
    return inheritUrl(base, custom);
  }

  private onChange = (index: number) => {
    this.setState({ current: index });
    if (this.props.onChange) {
      this.props.onChange(index, 1);
    }
  }
}

export default Pagination;
